import { Box } from '@mui/material';
import { useMemo } from 'react';
import { BikeleasingCalculator } from './BikeleasingCalculator';
import { BikeleasingContracts } from './BikeleasingContracts';
import { BikeleasingOverview } from './BikeleasingOverview';
import { BikeleasingRegister } from './BikeleasingRegister';
import { BikeleasingSetupPending } from './BikeleasingSetupPending';
import { BikeleasingVendor } from './BikeleasingVendor';
import { isBikeleasingSetupPending, useBikeleasingDetails } from './useBikeleasingDetails';

export enum BikeleasingTabs {
  overview = 'OVERVIEW',
  calculator = 'CALCULATOR',
  vendorMap = 'VENDOR_MAP',
}
interface Props {
  tab?: BikeleasingTabs;
}

export const BikeleasingContent: React.FC<Props> = ({ tab }) => {
  const setupPending = isBikeleasingSetupPending(useBikeleasingDetails());
  const component = useMemo(() => {
    if (setupPending) {
      return <BikeleasingSetupPending />;
    }

    switch (tab) {
      case BikeleasingTabs.overview:
        return (
          <Box
            sx={{
              marginX: 1,
              gap: 1,
            }}
          >
            <BikeleasingRegister />
            <BikeleasingContracts />
            <BikeleasingOverview />
          </Box>
        );
      case BikeleasingTabs.calculator:
        return <BikeleasingCalculator />;

      case BikeleasingTabs.vendorMap:
        return <BikeleasingVendor tab={tab} />;

      default:
        break;
    }
  }, [setupPending, tab]);

  return <>{component}</>;
};
